import eventCutoff from '../modules/eventCutoff';

eventCutoff.init();
